var map = {
	"./account.svg": 392,
	"./alertio.svg": 393,
	"./arrows-circle.svg": 394,
	"./arrows.svg": 395,
	"./bonus.svg": 396,
	"./cashbox.svg": 397,
	"./chevrons.svg": 398,
	"./common.svg": 399,
	"./controls.svg": 400,
	"./header.svg": 401,
	"./hint.svg": 402,
	"./icons.svg": 403,
	"./index-first-screen.svg": 404,
	"./input-messages.svg": 405,
	"./lobby.svg": 406,
	"./login.svg": 407,
	"./navigation.svg": 408,
	"./paper.svg": 409,
	"./profile.svg": 410,
	"./promotions.svg": 411,
	"./socials.svg": 412,
	"./support.svg": 413,
	"./themes.svg": 414,
	"./verification.svg": 415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 391;